import CONTACT_FIELDS from "@/lib/constants/contactFields";
import { SECTION_TYPES } from "@/lib/constants/sections";
import { Contact2 } from "lucide-react";

const contactFormSection = {
  type: SECTION_TYPES.CONTACT_FORM,
  content: {
    header: "Contact us",
    subheader: "We'd love to hear from you and answer any questions you may have.",
    bgImage: "https://ik.imagekit.io/4wu305uo4/contact-us.png?updatedAt=1715872145204",
    fields: CONTACT_FIELDS.filter((field) => field.mandatory),
  },
  meta: {
    displayName: "Contact form",
    displayDescription: "Direct your customers on contacting you with a form.",
    displayIcon: Contact2,
    variantsCount: 3,
  },
  aiPrompt() {
    return `For the Contact Form section, ensure that the form is user-friendly and easy to complete. 
    Provide clear instructions and minimize the number of required fields. 
    Use this section to reassure visitors that their inquiries will be handled promptly and professionally.`;
  },
};

export default contactFormSection;
